import { Wallet } from 'lucide-react'
import { TxRegistryTab, type TxRegistryConfig } from '@/components/TxRegistryTab'

const RECEIPT_TYPES = [
  ['cash', '1. 현금'], ['deposit', '2. 예금'], ['card', '3. 카드'], ['note', '4. 어음'],
  ['discount_prod', '5. 할인(상품)'], ['discount_made', '6. 할인(제품)'],
  ['prepay_cash', '7. 선수금(현금)'], ['prepay_dep', '8. 선수금(예금)'],
  ['prepay_clear', '9. 선수금정리'], ['offset', '10. 상계'],
  ['misc_loss', '11. 잡손실'], ['misc_gain', '12. 잡이익'],
] as const

const COLLECTIONS_CONFIG: TxRegistryConfig = {
  icon: <Wallet className="w-6 h-6 text-emerald-600"/>,
  headerTitle: '수금등록',

  entityShort: '수금',
  entityDateLabel: '수금일자',
  entityNoLabel: '수금번호',
  entityTypeLabel: '수금유형',
  partnerLabel: '거래처',
  searchPlaceholder: '수금번호, 거래처, 적요 검색',
  emptyText: '이 기간의 수금이 없습니다.',

  apiBase: '/api/collections',
  queryKey: 'collections',

  typeOptions: RECEIPT_TYPES,
  defaultType: 'cash',

  dateField: 'receipt_date',
  noField: 'receipt_no',
  typeField: 'receipt_type',
  typeLabelField: 'receipt_type_label',

  accent: {
    button: 'bg-emerald-600 hover:bg-emerald-700',
    total: 'text-emerald-700',
    typeChip: 'bg-emerald-100 text-emerald-800',
  },
}

export function CollectionsTab() {
  return <TxRegistryTab config={COLLECTIONS_CONFIG} />
}
